import script from "./PaymentFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentFooter.vue?vue&type=script&setup=true&lang=js"

import "./PaymentFooter.vue?vue&type=style&index=0&id=f43b7014&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f43b7014"]])

export default __exports__